/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Event_Group_OptionsInputs */

const en_editor_event_group_options = /** @type {(inputs: Editor_Event_Group_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event group options`)
};

const fr_editor_event_group_options = /** @type {(inputs: Editor_Event_Group_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options du groupe d'evenements`)
};

const de_editor_event_group_options = /** @type {(inputs: Editor_Event_Group_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optionen für Veranstaltungsgruppen`)
};

const it_editor_event_group_options = /** @type {(inputs: Editor_Event_Group_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni del gruppo di eventi`)
};

const ru_editor_event_group_options = /** @type {(inputs: Editor_Event_Group_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`параметры группы событий`)
};

const es_editor_event_group_options = /** @type {(inputs: Editor_Event_Group_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones de grupo de eventos`)
};

const zh_cn2_editor_event_group_options = /** @type {(inputs: Editor_Event_Group_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件组选项`)
};

const ja_editor_event_group_options = /** @type {(inputs: Editor_Event_Group_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループオプション`)
};

const hi_editor_event_group_options = /** @type {(inputs: Editor_Event_Group_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूह विकल्प`)
};

const pt_pt2_editor_event_group_options = /** @type {(inputs: Editor_Event_Group_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções de grupo de eventos`)
};

/**
* | output |
* | --- |
* | "Event group options" |
*
* @param {Editor_Event_Group_OptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_event_group_options = /** @type {((inputs?: Editor_Event_Group_OptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Event_Group_OptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_event_group_options(inputs)
	if (locale === "de") return de_editor_event_group_options(inputs)
	if (locale === "it") return it_editor_event_group_options(inputs)
	if (locale === "ru") return ru_editor_event_group_options(inputs)
	if (locale === "es") return es_editor_event_group_options(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_event_group_options(inputs)
	if (locale === "ja") return ja_editor_event_group_options(inputs)
	if (locale === "hi") return hi_editor_event_group_options(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_event_group_options(inputs)
	return en_editor_event_group_options(inputs)
});